/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rust_Quiet_Mouse_PantInputs */

const en_rust_quiet_mouse_pant = /** @type {(inputs: Rust_Quiet_Mouse_PantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter first name...`)
};

const de_rust_quiet_mouse_pant = /** @type {(inputs: Rust_Quiet_Mouse_PantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorname eingeben...`)
};

/**
* | output |
* | --- |
* | "Enter first name..." |
*
* @param {Rust_Quiet_Mouse_PantInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rust_quiet_mouse_pant = /** @type {((inputs?: Rust_Quiet_Mouse_PantInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rust_Quiet_Mouse_PantInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rust_quiet_mouse_pant(inputs)
	return de_rust_quiet_mouse_pant(inputs)
});